<template>
  <PdpErrorBoundary>
    <ErrorOwners :owners="['bot-squad-content-front']">
      <BlockSection v-if="section" :section />
    </ErrorOwners>
  </PdpErrorBoundary>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import BlockSection from '@backmarket/nuxt-layer-cms/BlockSection.vue'
import ErrorOwners from '@backmarket/nuxt-module-logger/components/ErrorOwners.vue'

import { useFetchFormattedCMSSections } from '~/scopes/cms/composables/useFetchFormattedCMSSections'
import PdpErrorBoundary from '~/scopes/product-core/components/presentationals/PdpErrorBoundary/PdpErrorBoundary.vue'

const props = defineProps<{
  index: 1 | 2 | 3 | 4 | 5
}>()
const { data: cmsSections } = useFetchFormattedCMSSections({ timeout: 2000 })

const section = computed(() => cmsSections.value?.[`section${props.index}`])
</script>
